export const CASES = {
    UPDATE_USERS: 'UPDATE_USERS',
    UPDATE_USER_FORM: 'UPDATE_USER_FORM',
    UPDATE_USERS_SEARCH_FORM: 'UPDATE_USERS_SEARCH_FORM',
    CLEAR_USERS: 'CLEAR_USERS',
    CLEAR_USER_FORM: 'CLEAR_USER_FORM',
};
